
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"13.333","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"document","d":"M12 9.333a.667.667 0 01-.667.667H6a.667.667 0 010-1.333h5.333a.667.667 0 01.667.666zm-2.667 2H6a.667.667 0 000 1.333h3.333a.667.667 0 000-1.333zm6-4.343v5.677A3.337 3.337 0 0112 16H5.333A3.337 3.337 0 012 12.667V3.333A3.337 3.337 0 015.333 0h3.01a4.639 4.639 0 013.3 1.367l2.323 2.324a4.634 4.634 0 011.367 3.3zM10.7 2.309a3.34 3.34 0 00-.7-.52v2.878a.667.667 0 00.667.667h2.877a3.322 3.322 0 00-.521-.7zM14 6.99c0-.11-.021-.215-.031-.323h-3.3a2 2 0 01-2-2v-3.3c-.108-.01-.214-.031-.323-.031H5.333a2 2 0 00-2 2v9.333a2 2 0 002 2H12a2 2 0 002-2z","transform":"translate(-2)","fill":"#727998"}})])
          )
        }
      }
    